export const formatCell = (value?: string | number | null | undefined) => {
  if (value === undefined || value === null || value === "") {
    return "N/A";
  }
  return value;
};
